// src/initRegistry.ts
type InitFn = () => void;

const initFunctions: InitFn[] = [];

export function registerInit(fn: InitFn) {
    initFunctions.push(fn);
}

// единый document ready
document.addEventListener("DOMContentLoaded", () => {
    for (const fn of initFunctions) {
        try {
            fn();
        } catch (e) {
            console.error("Init error:", e);
        }
    }
});
